// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SchoolWishList/Choose.less
// module id = 1625
// module chunks = 0